export default __webpack_public_path__ + "static/media/en_cours.8d530df4.svg";